import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateCustomerCheckoutPricingInfo } from '@hungryroot/plan';
import { postSubmitPromo } from '@hungryroot/rest/api/submit_promo/post';

export function useSubmitPromo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      orderId,
      promoCode,
    }: {
      orderId: number;
      promoCode: string;
    }) => {
      return await postSubmitPromo({ orderId, promo: promoCode });
    },
    onSuccess() {
      invalidateCustomerCheckoutPricingInfo(queryClient);
    },
  });
}
